import React from 'react';
import PropTypes from 'prop-types';
import { HelmetProvider } from 'react-helmet-async';

/**
 * Root component that conditionally wraps children in StrictMode based on environment
 * This helps prevent double-mounting of components in production
 * Also provides HelmetProvider for SEO management
 */
function Root({ children }) {
  // Use React.Fragment in production to prevent double-mounting
  // Use React.StrictMode in development for additional checks
  const RootComponent = import.meta.env.PROD ? React.Fragment : React.StrictMode;
  
  return (
    <HelmetProvider>
      <RootComponent>{children}</RootComponent>
    </HelmetProvider>
  );
}

Root.propTypes = {
  children: PropTypes.node.isRequired
};

export default Root;
